import React from 'react';
import { EasyClaimCaseResponseDto } from 'src/easyclaim.api.client.typescript/src';
import { IconArrowRight } from 'src/easyclaim.app.assets';

import { ChangeLanguageIcon } from './common/ImageRepository';

export interface ChangeLangButtonState {
	currentLang: string;
}

export interface ChangeLangButtonProps {
	onOpenChangeLangModal: () => void;
	currentLang: string;
	EasyClaimCase: EasyClaimCaseResponseDto;
}

export class ChangeLangButton extends React.Component<
	ChangeLangButtonProps,
	ChangeLangButtonState
> {
	render() {
		const currentLangUrl = this.props.EasyClaimCase?.localizedCaseUrls?.find(
			(l) => l.twoLetterLangCode === this.props.currentLang
		);

		return (
			<div className="change-lang-button" onClick={this.props.onOpenChangeLangModal}>
				<ChangeLanguageIcon currentLanguage={currentLangUrl?.twoLetterFlagCountryCode!} />
				<span style={{ marginLeft: '0.2rem' }}>{this.props.currentLang.toUpperCase()}</span>
				<IconArrowDown />
			</div>
		);
	}
}

const IconArrowDown = () => (
	<IconArrowRight height="1.1rem" width="1.1rem" style={{ transform: 'rotate(90deg)' }} />
);
